import Vue from 'vue';

import store from '@/store';
import App from '@/components/App';
import questions from '@/data/questions';

Vue.config.productionTip = false;

const images = [];

async function loadChoiceImages(choice) {
  const image = new Image();

  image.src = choice.response.image;

  images.push(image);
}

async function loadQuestionImages(question) {
  question.choices.forEach(loadChoiceImages);
}

async function loadImages() {
  questions.forEach(loadQuestionImages);
}

loadImages();

new Vue({
  store,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js